import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { useVariableLoadedListener } from 'hooks/useVariableLoadedListener'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { P5Init, useP5 } from 'views/InhouseGame/hooks/useP5'

const Sketch: React.FC<P5Init & BoxProps> = ({ draw, setup, ...props }) => {
  const containerRef = useRef(null)

  const { init, isLoaded } = useP5()
  const container = useVariableLoadedListener(() => containerRef.current)

  useEffect(() => {
    if (isLoaded && container) {
      init(setup, draw, container)
    }
  }, [isLoaded, container])

  return <StyledContainer {...props} ref={containerRef} />
}

const StyledContainer = styled(Box)`
  display: flex;
  justify-content: center;
  top: 0px;
`
const MemoSketch = React.memo(Sketch)
export default MemoSketch
